import React from "react"
import "./footer.css"

const Footer = () => {
  return (
    <footer>
      <ul>
        <li>Terms of Use</li>
        <li>Privacy Policy</li>
        <li>Cookies</li>
      </ul>
    </footer>
  )
}

export default Footer
